import { gql } from 'apollo-angular';
export const SERVICES = gql`
query services($paginationOptions:PaginationOptions!){
  services(paginationOptions:$paginationOptions) {
    serviceId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
	imageUrl
  thumbnail
  }
}
`;

export const SESSIONS_BY_SERVICE_ID = gql`
query sessionsByServiceId($getSessionsByService: GetSessionsByServiceIdInput!){
  sessionsByServiceId(getSessionsByService:$getSessionsByService){
    sessionId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `descriptionAr`
        : `description`
    }
    price
    salePrice
    imageUrl
  }
}
`;

export const SUCCESS_STORIES_BY_SERVICE_ID = gql`
  query successStoriesByServiceId(
    $getSuccessStoriesByServiceIdInput: GetSuccessStoriesByServiceIdInput!
  ) {
    successStoriesByServiceId(
      getSuccessStoriesByServiceIdInput: $getSuccessStoriesByServiceIdInput
    ) {
      successStoryId
      beforeImage
      afterImage
    }
  }
`;

export const GET_FQA_BY_SERVICE_ID = gql`
query getFaqByServiceId($getFaqByServiceIdInput: FaqByServiceIdInput!){
  getFaqByServiceId(getFaqByServiceIdInput:$getFaqByServiceIdInput){
    frequentlyAskedQuestionId
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `questionAr`
        : `question`
    }
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `answerAr` : `answer`}
  }
}
`;
export const SERVICE = gql`
query service($getServiceInput:GetServiceInput!){
  service(getServiceInput:$getServiceInput) {
    serviceId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `descriptionAr`
        : `description`
    }
    imageUrl
    thumbnail
  }
}
`;

export const OFFERS = gql`
query offers($paginationOptions:PaginationOptions!){
  offers(paginationOptions:$paginationOptions) {
    sessionId
    serviceId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `descriptionAr`
        : `description`
    }
    imageUrl
    price
    sale
    salePrice
  }
}
`;

export const HEALTHEDUCATIONS = gql`
query healthEducations($paginationOptions:PaginationOptions!){
  healthEducations(paginationOptions:$paginationOptions) {
    healthEducationId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `titleAr` : `title`}
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `bodyAr` : `body`}
    foregroundImage
  }
}
`;

export const HEALTHEDUCATION = gql`
query healthEducation($getHealthEducationInput: GetHealthEducationInput!){
  healthEducation(getHealthEducationInput:$getHealthEducationInput) {
    healthEducationId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `titleAr` : `title`}
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `bodyAr` : `body`}
    foregroundImage
    healthEducationCategoryId
  }
}
`;

export const HEALTHEDUCATION_BY_CATEGORY = gql`
query healthEducationsByCategory($getHealthEducationByCategoryIdInput: GetHealthEducationByCategoryIdInput!){
  healthEducationsByCategory(getHealthEducationByCategoryIdInput:$getHealthEducationByCategoryIdInput) {
    healthEducationId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `titleAr` : `title`}
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `bodyAr` : `body`}
    foregroundImage
    healthEducationCategoryId
  }
}
`;

export const ALLNEWS = gql`
query allNews($paginationOptions:PaginationOptions!){
  allNews(paginationOptions:$paginationOptions) {
    newsCategoryId
    newsId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `titleAr` : `title`}
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `bodyAr` : `body`}
    foregroundImage
  }
}
`;

export const TESTIMONIALS = gql`
  query testimonials($paginationOptions: PaginationOptions!) {
    testimonials(paginationOptions: $paginationOptions) {
      testimonialId
      name
      content
      imageUrl
    }
  }
`;

export const OUR_TEAM = gql`
query ourTeam($paginationOptions:PaginationOptions!) {
  ourTeam(paginationOptions:$paginationOptions) {
    ourTeamId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `positionAr`
        : `position`
    }
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `aboutAr` : `about`}
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `experienceAr`
        : `experience`
    }
    imageUrl
  }
}
`;

export const TEAM_MEMBER = gql`
query teamMember($getTeamMemberInput: GetTeamMemberInput!){
  teamMember(getTeamMemberInput:$getTeamMemberInput) {
    ourTeamId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `positionAr`
        : `position`
    }
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `aboutAr` : `about`}
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `experienceAr`
        : `experience`
    }
    imageUrl
  }
}
`;

export const VACANCY = gql`
query vacancy($getVacancyInput: GetVacancyInput!){
  vacancy(getVacancyInput:$getVacancyInput) {
    vacancyId
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `positionAr`
        : `position`
    }
    imageUrl
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `addressAr`
        : `address`
    }
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `experienceAr`
        : `experience`
    }
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `workingHoursAr`
        : `workingHours`
    }
    vacanciesNumber
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `jobSystemAr`
        : `jobSystem`
    }
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `genderAr` : `gender`}
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `salaryAr` : `salary`}
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `skillsAr` : `skills`}
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `responsibilitiesAr`
        : `responsibilities`
    }
    isOpened
  }
}
`;

export const VACANCIES = gql`
query vacancies($paginationOptions:PaginationOptions!){
  vacancies(paginationOptions:$paginationOptions) {
    vacancyId
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `positionAr`
        : `position`
    }
    imageUrl
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `addressAr`
        : `address`
    }
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `experienceAr`
        : `experience`
    }
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `workingHoursAr`
        : `workingHours`
    }
    vacanciesNumber
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `jobSystemAr`
        : `jobSystem`
    }
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `genderAr` : `gender`}
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `salaryAr` : `salary`}
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `skillsAr` : `skills`}
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `responsibilitiesAr`
        : `responsibilities`
    }
    isOpened
  }
}
`;

export const NEWSDETAILS = gql`
query news($getNewsInput: GetNewsInput!){
  news(getNewsInput:$getNewsInput) {
    newsCategoryId
    newsId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `titleAr` : `title`}
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `bodyAr` : `body`}
    foregroundImage
  }
}
`;

export const NEWS_BY_CATEGORY = gql`
query relatedNews($paginationOptions:PaginationOptions!, $newsCategoryId: String!){
  relatedNews(paginationOptions:$paginationOptions, newsCategoryId:$newsCategoryId) {
    newsId
    newsCategoryId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `titleAr` : `title`}
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `bodyAr` : `body`}
    foregroundImage
  }
}
`;

export const SLOGANS = gql`
query slogans {
  slogans {
  sloganId
  ${
    localStorage.getItem('lang')?.indexOf('ar') != -1
      ? `homeHeaderTitleAr`
      : `homeHeaderTitle`
  }
  ${
    localStorage.getItem('lang')?.indexOf('ar') != -1
      ? `homeServicesTitleAr`
      : `homeServicesTitle`
  }
  ${
    localStorage.getItem('lang')?.indexOf('ar') != -1
      ? `homeServicesDescriptionAr`
      : `homeServicesDescription`
  }
  ${
    localStorage.getItem('lang')?.indexOf('ar') != -1
      ? `homeOffersTitleAr`
      : `homeOffersTitle`
  }
  ${
    localStorage.getItem('lang')?.indexOf('ar') != -1
      ? `homeHealthEducationTitleAr`
      : `homeHealthEducationTitle`
  }
  ${
    localStorage.getItem('lang')?.indexOf('ar') != -1
      ? `homeCustomerOpinionsTitleAr`
      : `homeCustomerOpinionsTitle`
  }
  ${
    localStorage.getItem('lang')?.indexOf('ar') != -1
      ? `homeNewsTitleAr`
      : `homeNewsTitle`
  }
  ${
    localStorage.getItem('lang')?.indexOf('ar') != -1
      ? `homeHeaderImage2`
      : `homeHeaderImage`
  }
  ${
    localStorage.getItem('lang')?.indexOf('ar') != -1
      ? `bookTitleAr`
      : `bookTitle`
  }
  bookImage
  }
}
`;

export const ABOUT = gql`
query about {
  about {
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `summaryTitleAr`
        : `summaryTitle`
    }
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `summaryDescriptionAr`
        : `summaryDescription`
    }
    summaryImage
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `ourMessageTitleAr`
        : `ourMessageTitle`
    }
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `ourMessageDescriptionAr`
        : `ourMessageDescription`
    }
    ourMessageImage
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `ourVisionTitleAr`
        : `ourVisionTitle`
    }
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `ourVisionDescriptionAr`
        : `ourVisionDescription`
    }
    ourVisionImage
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `executiveManagerWordTitleAr`
        : `executiveManagerWordTitle`
    }
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `executiveManagerWordDescriptionAr`
        : `executiveManagerWordDescription`
    }
    executiveManagerWordImage
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `medicalManagerWordTitleAr`
        : `medicalManagerWordTitle`
    }
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `medicalManagerWordDescriptionAr`
        : `medicalManagerWordDescription`
    }
    medicalManagerWordImage
    ourValues{
      ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `titleAr` : `title`}
      icon
    }
  }
}
`;

export const SESSIONS = gql`
query sessions($paginationOptions:PaginationOptions!){
  sessions(paginationOptions:$paginationOptions) {
    sessionId
    serviceId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `descriptionAr`
        : `description`
    }
    imageUrl
    price
    sale
    salePrice
  }
}
`;

export const SESSION = gql`
query session($getSessionInput: GetSessionInput!){
  session(getSessionInput:$getSessionInput) {
    sessionId
    serviceId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `descriptionAr`
        : `description`
    }
    imageUrl
    price
    sale
    salePrice
  }
}
`;

export const CART = gql`
query cart($cartId: String!){
  cart(cartId:$cartId) {
    cartId 
    tax
    price
    totalPrice
    items{
      product_id
      branch
      cartItemId 
      offer_code 
      lst_price 
      qty 
      arabic_name 
      english_name 
      image
      }
  }
}
`





export const MEMBERSHIPS = gql`
query memberships($paginationOptions:PaginationOptions!){
  memberships(paginationOptions:$paginationOptions) {
    membershipId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `titleAr` : `title`}
    icon
  }
}
`;

export const MEMBERSHIP = gql`
query membership($getMembershipByIdInput:GetMembershipByIdInput!){
  membership(getMembershipByIdInput:$getMembershipByIdInput) {
    membershipId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `titleAr` : `title`}
    questionsAndAnswers {
      ${
        localStorage.getItem('lang')?.indexOf('ar') != -1
          ? `questionAr`
          : `question`
      }
      ${
        localStorage.getItem('lang')?.indexOf('ar') != -1
          ? `answerAr`
          : `answer`
      }
    }
    icon
  }
}
`;

export const SETTING = gql`
query setting {
  setting {
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `addressAr`
        : `address`
    }
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `workingHoursAr`
        : `workingHours`
    }
    email
    mobile
    facebook
    twitter
    instagram
    linkedIn
    snapchat
    logo
    appleStoreLink
    androidStoreLink
    locationLink
    latitude
    longitude
  }
}
`;

export const FAQ_BY_SERVICE_ID = gql`
query getFaqByServiceId($getFaqByServiceIdInput: FaqByServiceIdInput!) {
  getFaqByServiceId(getFaqByServiceIdInput:$getFaqByServiceIdInput) {
    frequentlyAskedQuestionId
    serviceId
    ${
      localStorage.getItem('lang')?.indexOf('ar') != -1
        ? `questionAr`
        : `question`
    }
     ${
       localStorage.getItem('lang')?.indexOf('ar') != -1 ? `answerAr` : `answer`
     }
  }
}`;

export const REGIONS = gql`
query regions {
  regions {
    regionId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
  }
}`;

export const CITIES = gql`
query cities {
  cities {
    cityId
    regionId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
  }
}`;

export const DEGREES = gql`
query degrees {
  degrees {
    degreeId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
  }
}`;

export const SPECIALILITIES = gql`
query specialities {
  specialities {
    specialityId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
  }
}`;

export const EXPERIENCES = gql`
query experiences {
  experiences {
    yearsOfExperienceId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `titleAr` : `title`}
  }
}`;

export const LANGUAGES = gql`
query languages {
  languages {
    languageId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
  }
}`;

export const LANGUAGE_LEVELS = gql`
query languageLevels {
  languageLevels {
    languageLevelId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
  }
}`;

export const CITIES_BY_REGION_ID = gql`
query citiesByRegionId($getCitiesByRegionIdInput: GetCitiesByRegionIdInput!) {
  citiesByRegionId(getCitiesByRegionIdInput:$getCitiesByRegionIdInput) {
    cityId
    regionId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
  }
}`;

export const OUR_MEMORIES = gql`
  query ourMemories($paginationOptions: PaginationOptions!) {
    ourMemories(paginationOptions: $paginationOptions) {
      ourMemoryId
      image
    }
  }
`;

export const NATIONALITIES = gql`
query nationalities {
  nationalities {
    nationalityId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
  }
}`;

export const IDENTITY_TYPES = gql`
query identityTypes {
  identityTypes {
    identityTypeId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
  }
}`;

export const GENDER = gql`
query genders {
  genders {
    genderId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
  }
}`;

export const SOCIAL_STATUS = gql`
query socialStatuses {
  socialStatuses {
    socialStatusId
    ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
  }
}`;

export const CUSTOMER_CONSULTATIONS = gql`
  query customerConsultations(
    $customerConsultationsInput: CustomerConsultationsInput!
  ) {
    customerConsultations(
      customerConsultationsInput: $customerConsultationsInput
    ) {
      consultationId
      userId
      content
      createdAt
    }
  }
`;

export const CONSULTATIONS_REPLIES = gql`
  query consultationReplies(
    $getConsultationReplies: GetConsultationRepliesInput!
  ) {
    consultationReplies(getConsultationReplies: $getConsultationReplies) {
      consultationReplyId
      consultationId
      userId
      content
      createdAt
      commentByUserType
      repliedUser {
        firstName
        lastName
      }
    }
  }
`;

export const CONSULTATION = gql`
  query consultation($getConsultationInput: GetConsultationInput!) {
    consultation(getConsultationInput: $getConsultationInput) {
      consultationId
      userId
      content
      createdAt
    }
  }
`;

export const CUSTOMER_APPOINTMENTS = gql`
query customerAppointments($paginationOptions:PaginationOptions!) {
  customerAppointments(paginationOptions: $paginationOptions) {
    appointmentId
    timeslotId
    session{
      sessionId
        ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `nameAr` : `name`}
        ${
          localStorage.getItem('lang')?.indexOf('ar') != -1
            ? `descriptionAr`
            : `description`
        }
        price
        salePrice
    }
    firstName
    lastName
    appointmentDate
  }
}`;

export const CUSTOMER = gql`
  query customer {
    customer {
      customerId
      email
      firstName
      lastName
      phoneNumber
      avatar
    }
  }
`;

export const APPOINTMENT_AVAILABLE_SLOTS = gql`
query appointmentAvailableSlots($getAvailableTimeSlots: GetAppointmentAvailableSlotsInput!) {
  appointmentAvailableSlots(getAvailableTimeSlots:$getAvailableTimeSlots) {
    dayCode
    dayDate
    availableSlots{
      timeslotId
      serviceId
      ${localStorage.getItem('lang')?.indexOf('ar') != -1 ? `titleAr` : `title`}
      dayCode
    }
  }
}
`;

export const VALIDATE_CUSTOMER_TOKEN = gql`
  query validateCustomerToken {
    validateCustomerToken {
      message
    }
  }
`;

export const FORM = gql`
  query GetSingleForm($getFormInput: GetFormInput!) {
    form(getFormInput: $getFormInput) {
      formId
      formTitle
      fields
      branch
      specialOffersValues
    }
  }
`;
